import React from "react"

import CheckBox from "../CheckBox"
import TimeIntervalPicker from "../TimeIntervalPicker"

import styles from "./OpeningHoursPicker.module.css"
import {DAYS_OF_THE_WEEK} from "../../constants/datetime"
import {DEFAULT_PAYEE_DAILY_OPENING_HOURS} from "../../constants/payeeCatalog"
import {convert24HrTimeFormatTo12HrTime} from "../../utils/datetimeUtils"
import {capitalize} from "../../utils/stringUtils"

class OpeningHoursPicker extends React.PureComponent {
    
    
    static defaultProps = {
        openingHours: {},
        onChange: () => {},
        editable: true,
        allowClosedAllDays: false
    }

    handleChangeDayIsClosed = (dayOfTheWeek, isClosed) => {
        const {onChange, allowClosedAllDays} = this.props
        const openingHours = {...this.props.openingHours}
        let confirmationPrompt
        if (isClosed) {
            delete openingHours[dayOfTheWeek]
            confirmationPrompt = `Are you sure you want to close on ${capitalize(dayOfTheWeek)}s?`
        }
        else {
            openingHours[dayOfTheWeek] = DEFAULT_PAYEE_DAILY_OPENING_HOURS
            confirmationPrompt = `Are you sure you want to open on ${capitalize(dayOfTheWeek)}s?`
        }
        if (!allowClosedAllDays){
            //check to confirm that there is at least one open day
            if (Object.keys(openingHours).length === 0 ) {
                alert("Sorry, you must open on at least one day")
                return
            }
        } 
        onChange(openingHours, confirmationPrompt)
    }

    handleChangeTimeInterval = (timeInterval, dayOfTheWeek) => {
        const {onChange} = this.props
        const openingHours = {...this.props.openingHours}
        //if somehow, the day is closed, return
        if (!openingHours[dayOfTheWeek]) return
        //update the key (openingTime/closingTime) to the specified time
        const {fromTime, toTime} = timeInterval
        const dayOpeningHours = {
            ...openingHours[dayOfTheWeek],
            openingTime: fromTime,
            closingTime: toTime
        }
        openingHours[dayOfTheWeek] = dayOpeningHours
        onChange(openingHours, `Are you sure you want to change the opening hours to ${convert24HrTimeFormatTo12HrTime(fromTime)} to ${convert24HrTimeFormatTo12HrTime(toTime)}?`)
    }
    render() {
        const {openingHours, editable} = this.props
        return (
            <div className="font-size-14px">
                {
                    DAYS_OF_THE_WEEK.map(dayOfTheWeek => {
                        const dayOpeningHours = openingHours[dayOfTheWeek]
                        const {openingTime, closingTime} = dayOpeningHours ? dayOpeningHours : {}
                        const isClosed = !openingTime || !closingTime
                        return <DayOpeningHours
                                    key={dayOfTheWeek}
                                    day={dayOfTheWeek}
                                    openingTime={openingTime}
                                    closingTime={closingTime}
                                    isClosed={isClosed}
                                    onChangeDayIsClosed={this.handleChangeDayIsClosed}
                                    onChangeTimeInterval={this.handleChangeTimeInterval}
                                    editable={editable}
                                />
                    })
                }
            </div>
        )
    }
}

const DayOpeningHours = ({
    day, openingTime="", closingTime="", isClosed=false, 
    onChangeDayIsClosed=()=>{}, onChangeTimeInterval=()=>{}, editable=true
}) => {
    if (!day) return ""
    return (
        <div className={styles.dayOpeningHoursContainer}>
            <div className={styles.day}>
                <div>
                    <CheckBox 
                        checked={!isClosed} 
                        onChange={() => onChangeDayIsClosed(day, !isClosed)}
                        editable={editable}
                    />
                </div>
                <div>{day}</div>
            </div>
            <div className={styles.hours}>
                {
                    isClosed ?
                    <div>Closed</div>
                    :
                    editable ?
                    <TimeIntervalPicker 
                        timeInterval={{fromTime: openingTime, toTime:closingTime}}
                        onChange={timeInterval => onChangeTimeInterval(timeInterval, day)}
                    />
                    :
                    <div>{convert24HrTimeFormatTo12HrTime(openingTime)} - {convert24HrTimeFormatTo12HrTime(closingTime)}</div>
                }
            </div>
            
        </div>
    )
}

export default OpeningHoursPicker